(function () {
    'use strict';

    var OutlineViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/outline-view.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            onChange: '&'
        },
        controller: ['$scope', '$timeout', 'Qinius', 'MessageService', 'UidService','ImgprocContours', '$q',
            function ($scope, $timeout, Qinius, MessageService, UidService, ImgprocContours, $q) {
                var vm = this;
                vm.page = angular.copy(vm.page);
                vm.page.background = null;
                vm.outlineWidth = 2;
                vm.errorImage = null;
                if(vm.page.levels.level && vm.page.levels.level.length > 0){
                    vm.page.levels.level = vm.page.levels.level.filter(function(item){
                        return item.imagebox
                    });
                    if(!vm.page.levels.level.length){
                        MessageService.error('没有图片框，不能生成刀线');
                        vm.onChange();
                        return false;
                    }
                }else{
                    MessageService.error("空白页无法生成刀线");
                    vm.onChange();
                    return false;
                }
                vm.width = PxTurnMm(vm.page.mediabox.width);
                vm.height = PxTurnMm(vm.page.mediabox.height);
                vm.threeLoading=false;
                vm.threeLoadingText = "刀线图生成中...";
                $scope.domain = Qinius.getDomain();
                vm.token = Qinius.get();
                vm.scale = 1;
                vm.scale1 = 1;
                vm.thumbnailScale = 1;
                vm.windowWidth = 600;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale = vm.windowWidth / vm.page.mediabox.width;
                } else {
                    vm.scale = vm.windowWidth / vm.page.mediabox.height;
                }
                vm.windowWidth1 = vm.isMobile ? 260 : 360;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.width;
                } else {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.height;
                }
                
                $q.all([$scope.domain.$promise, vm.token.$promise]).then(function () {
                    vm.token = vm.token.token;
                    $scope.domain = $scope.domain.domain;
                    $scope.page = vm.page;
                    $scope.page.notTrimbox = true;
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.outlineWidth = $scope.page.outline.contourWidth || 0;
                    }
                    // if(!$scope.page.outline){
                    //     vm.threeLoading=true;
                    //     thumbnailInit(function(url){
                    //         generateContour(url);
                    //     })
                    // }
                });
                function generateContour(url){
                    ImgprocContours.generateContour({
                        "page": {
                            "front": url  // 必填，图像URL或base64数据
                        },
                        "pageSize": {          // 可选，期望输出尺寸（毫米）
                            "width": vm.width,
                            "height": vm.height
                        },
                        "contourWidth": Number(vm.outlineWidth),   // 可选，描边宽度（毫米），默认2.0
                        "smoothFactor": 3,      // 可选，平滑因子，默认0
                        "mirrorable": true
                    },function(res){
                        if(res && res.data){
                            res.data.image = url;
                        }
                        imgprocSuccess(res,'cutline');
                    },imgprocError)
                }
                function imgprocSuccess(res,type) {
                    vm.threeLoading=false;
                    if(res.success){
                        if(res.data && res.data.success){
                            $scope.page.outline = {
                                type: type,
                                contourWidth: vm.outlineWidth,
                                geometry: res.data.mmRect,
                                cutline:{
                                    resource:{
                                        identifier: res.data.contourUrl
                                    },
                                },
                            }
                            if(res.data.mirror){
                                $scope.page.outline.mirrorCutline = {
                                    resource:{
                                        identifier: res.data.mirror.contourUrl
                                    }
                                }
                            }
                            console.log($scope.page)
                            $scope.$apply();
                        }else{
                            vm.errorImage = res.data;
                        }
                    }else{
                        MessageService.error(res.error);
                    }
                }
                function imgprocError(err) {
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.outlineWidth = $scope.page.outline.contourWidth;
                    }
                    vm.threeLoading=false;
                    MessageService.error(err.data.error || "刀线生成失败");
                }
                //生成封面图
                function thumbnailInit(callback) {
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-outline'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    var url = canvas.toDataURL("image/png");
                                    var blob = dataURLtoBlob(url);
                                    var formData = new FormData();
                                    formData.append('file', blob);
                                    formData.append('key', '3dThumbnail-' + UidService.get());
                                    formData.append('token', vm.token);
                                    $.ajax({
                                        cache: true,
                                        type: "POST",
                                        url: 'https://upload.qiniup.com/',
                                        data: formData,
                                        async: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (data) {
                                            callback($scope.domain + data.key)
                                        },
                                        error: function () {
                                            callback()
                                        }
                                    })
                                }else{
                                    callback()
                                }
                            },
                            error:function(){
                                callback()
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: $scope.page.custom.width * vm.thumbnailScale,
                            height: $scope.page.custom.height * vm.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            dpi:300
                        });
                    })
                }
                $scope.resetOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                    vm.threeLoading=true;
                    thumbnailInit(function(url){
                        generateContour(url,'cutline');
                    })
                }
                $scope.removeOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                }
                window.updatePic = function ($event) {
                    $timeout(function () {
                        vm.errorImage = null;
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            MessageService.error("您上传的图片格式为"+file.type+"，刀线图仅支持png格式，请重新上传");
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = "刀线图生成中...";
                        uploadImage(file, function(data){
                            if(data && data.key){
                                ImgprocContours.parseContour({
                                    "page": {
                                        "contour": $scope.domain + data.key
                                    },
                                    "pageSize": {          // 可选，期望输出尺寸（毫米）
                                        "width": vm.width,
                                        "height": vm.height
                                    },
                                    "contourWidth": vm.outlineWidth,   // 可选，描边宽度（毫米），默认2.0
                                    "smoothFactor": 3,      // 可选，平滑因子，默认0
                                    "mirrorable": true
                                },function(res){
                                    if(res && res.data){
                                        res.data.image = $scope.domain + data.key
                                    }
                                    $scope.page.outline = null;
                                    $scope.page.outlineSpread = null;
                                    imgprocSuccess(res,'customized');
                                },imgprocError)
                            }else{
                                vm.threeLoading=false;
                                MessageService.error("上传失败");
                                $scope.$apply();
                            }
                        },function(err){
                            vm.threeLoading=false;
                            MessageService.error("上传失败");
                            $scope.$apply();
                        })
                    })
                };
                
                function uploadImage(file, callback) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('key', 'gallery-' + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            if(callback){callback(data)}
                        },
                        error: function (request) {
                            if(callback){callback()}
                        }
                    });
                }
                var outlineWidthDebounce;
                vm.changeOutlineWidth = function () {
                    var outlineWidth = Number(vm.outlineWidth);
                    if (!$scope.page || outlineWidth < 0 || outlineWidth > 5 || isNaN(outlineWidth)) {
                        return;
                    }
                    if (outlineWidthDebounce) {
                        $timeout.cancel(outlineWidthDebounce);
                    }
                    outlineWidthDebounce = $timeout(function () {
                        vm.threeLoading = true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        });
                    }, 500);
                };
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    vm.onChange({text:$scope.page});
                }
            }]
    };

    angular.module('platformApp')
        .component('outlineView', OutlineViewControl);

})();
